import { Space } from "antd";
import React from "react";
import { CustomInputNumber } from "./CustomInputNumber";
import { CustomSelectField } from "./CustomSelectField";

const MONTH_OPTIONS = [
  { value: 1, label: "January" },
  { value: 2, label: "February" },
  { value: 3, label: "March" },
  { value: 4, label: "April" },
  { value: 5, label: "May" },
  { value: 6, label: "June" },
  { value: 7, label: "July" },
  { value: 8, label: "August" },
  { value: 9, label: "September" },
  { value: 10, label: "October" },
  { value: 11, label: "November" },
  { value: 12, label: "December" },
];

/**
 * Manual date entry as a Month dropdown (stores 1-12), a Day input and a Year
 * input — the layout used for pilot date of birth, extracted so it can be
 * reused (e.g. accident/claim dates). No calendar/date-picker involved.
 *
 * Pass the three field names; each part is its own react-hook-form field so
 * validation and error display match the rest of the form.
 */
export const MonthDayYearInput = ({
  control,
  monthName,
  dayName,
  yearName,
  required = false,
  showErrors,
  shouldHideErrors = true,
}) => {
  return (
    <Space>
      <CustomSelectField
        shouldHideErrors={shouldHideErrors}
        showErrors={showErrors}
        options={MONTH_OPTIONS}
        formItem={{ required }}
        style={{ width: 105 }}
        control={control}
        name={monthName}
        placeholder="Month"
        listHeight={500}
      />
      <CustomInputNumber
        formItem={{ required }}
        maxLength={2}
        style={{ width: 90 }}
        control={control}
        name={dayName}
        placeholder="Day"
        shouldHideErrors={shouldHideErrors}
        showErrors={showErrors}
      />
      <CustomInputNumber
        formItem={{ required }}
        maxLength={4}
        style={{ width: 90 }}
        control={control}
        name={yearName}
        placeholder="Year"
        shouldHideErrors={shouldHideErrors}
        showErrors={showErrors}
      />
    </Space>
  );
};
